<template>
  <div class="show-letter">
    <div v-if="letter!==null">
      <Letter :selectedLetter="letter"/>
      <button type="button" name="button" class="btn btn-danger" @click="deleteLetter(letter.id)">delete</button>
    </div>
  </div>
</template>
<script>
import Letter from '@/components/Letter.vue'
import firebase from 'firebase'

export default {
  name: 'show-letter',
  components: {
    Letter
  },
  data() {
    return {
      letter: null,
      db: null
    }
  },
  methods: {
    deleteLetter(id){
      let db = this.db;
      let vue = this;
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          // lettersコレクションから削除する
          db.collection('letters').doc(id).delete().then(function() {
            // users.uid.lettersから削除する
            db.collection('users').doc(user.uid).collection('letters').doc(id).delete().then(function() {
                console.log("Document successfully deleted!");
                vue.$router.push('/');
            }).catch(function(error) {
                console.error("Error removing document: ", error);
            });
          }).catch(function(error) {
              console.error("Error removing document: ", error);
          });
        }
      })
    }
  },
  created() {
    this.db = firebase.firestore();
    let vue = this;
    this.letter = this.db.collection('letters').doc(this.$route.params.id).get().then(es=>{
      vue.letter = es.data();
      vue.letter.id = es.id;
    });
  }
}
</script>
<style scoped>
</style>
